module.exports = __webpack_public_path__ + "static/media/bg_loop_music.dc64ee3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/bg_loop_music.mp3
// module id = uAMF
// module chunks = 5